import { render, staticRenderFns } from "./ResearchResourceCategory.vue?vue&type=template&id=4340ed8d&scoped=true&"
import script from "./ResearchResourceCategory.vue?vue&type=script&lang=js&"
export * from "./ResearchResourceCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4340ed8d",
  null
  
)

export default component.exports